/**
 * Created by lautaro on 23/11/17.
 */
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MainComponent} from "./main/main.component";

const libraryRoutes: Routes = [
    {
        path: 'library',
        component: MainComponent
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(libraryRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class LibraryRoutingModule {
}


// WEBPACK FOOTER //
// ./src/app/library/routing.module.ts